$(function () {
   var GAiiv = function isInView(o) {
          typeof o[0] === 'undefined' ? o = o : o = o[0];
          if (o instanceof HTMLElement) {
              var vph = window.innerHeight, wpw = window.innerWidth;
              var oRect = o.getBoundingClientRect();
              var ott = oRect.top + oRect.height * 0.5;
              var otl = oRect.left + oRect.width * 0.5;
              return (ott > 0 && ott < vph && otl > 0 && otl < wpw);
          } else { return false; }
 }
      var GAgdb = function gaDebounce(fn, wait) {
          var timeout = null;
          return function () {
              if (timeout !== null) { clearTimeout(timeout); }
              timeout = setTimeout(fn, wait);
          }
 }
  function sendLocalinfo(promitionid,promoname){
      var ga_prInfo=localStorage.getItem("ga_prInfo");
      if(ga_prInfo){
          localStorage.removeItem("ga_prInfo");
      }
            localStorage.setItem('ga_prInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                    promotion_id: promitionid, 
                    promotion_name: promoname
                    }));
}
function sendProlistname(prolistname){
      var ga_ilInfo=localStorage.getItem("ga_ilInfo");
      if(ga_ilInfo){
          localStorage.removeItem("ga_ilInfo");
      }
           localStorage.setItem('ga_ilInfo',JSON.stringify({
                    ts: Date.now()+3600*24*30*1000,
                     item_list_name: prolistname
                    }));
}
function getLocalinfo(localstring){
  var ga_prInfo=localStorage.getItem(localstring);
   var sitems=new Array(); 
  if(ga_prInfo){
    var obj=JSON.parse(ga_prInfo)
    if(obj.ts>Date.now()){
        last_prid=obj.promotion_id;
        sitems.push(last_prid);
        last_prnm=obj.promotion_name;
        sitems.push(last_prnm);
    }
    return sitems;
  }
}
    function sendProindex(productid,listname,index){
                 var ga_proIndex=localStorage.getItem("ga_proIndex");
                 if(ga_proIndex){
                      var proflag =0;
                      var objArrs=JSON.parse(ga_proIndex);
                      for(var i=0;i<objArrs.length;i++){
                        var objInfos = objArrs[i];
                        if(objInfos.productid == productid && objInfos.prolistname == listname){
                            objArrs.splice(i,1);   
                          var arrInfos = {
                              productid: productid,
                              prolistname: listname,
                              proindex: index,
                              ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                           break;
                        }else{
                          proflag++;
                        }
                    }
                    if(proflag == objArrs.length){
                       var arrInfos = {
                               productid: productid,
                               prolistname: listname,
                               proindex: index,
                               ts: Date.now()+3600*24*30*1000
                            };
                            objArrs.push(arrInfos);
                            localStorage.setItem('ga_proIndex',JSON.stringify(objArrs));
                    }
                 }else{
                      var proArray = new Array();
                      var arrInfo = {
                             productid: productid,
                             prolistname: listname,
                             proindex: index,
                             ts: Date.now()+3600*24*30*1000
                            };
                       proArray.push(arrInfo);
                     localStorage.setItem('ga_proIndex',JSON.stringify(proArray));
                 }
  }
  // homepage imglists
    var bthreeflag={};
  function viewHomeadthree(){
    var imgitems=new Array();
    $("#homepage_bot-imglists .custom__item").each(function(){
           var imgindex=$(this).find("img").attr("alt");
           var csl=$(this).index();
           var iid = "homepage_text-img-ad_image";
           var pid = "homepage_text-img-ad_image";
           var cnm = $(this).find("img").attr("src");
           var pnm = $(this).find("img").attr("alt");
           if(GAiiv($(this))&&bthreeflag[csl] !== csl){
               imgitems.push({
                   "item_id": iid,
                   "item_name": pnm,
                   "promotion_id": pid,
                   "promotion_name": pnm,
                   "creative_name": cnm,
                   "creative_slot": csl
               }); 
               bthreeflag[csl] = csl
           }
    });
     if(imgitems.length>0){
           // console.log({
           //     "event":  "dle_view_promotion",
           //     "ecommerce":  {
           //         "items": imgitems
           //     }
           // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_promotion",
              "ecommerce": {
                "items": imgitems
              }
          })
       };
  }
   function viewtextimgHandle(){
       viewHomeadthree();
   }
  window.addEventListener('scroll', GAgdb(viewtextimgHandle,1000));
    $("#homepage_bot-imglists .custom__item").click(function(){
     var imgindex = $(this).index();
     var csl = imgindex;
     var cnm = $(this).find("img").attr("src");
     var pnm = $(this).find("img").attr("alt");
     var iid = "homepage_text-img-ad_image";
     var pid = "homepage_text-img-ad_image";
     var promotionid = pid;
      var promoname = pnm;
      sendLocalinfo(promotionid,promoname);
                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_promotion",
                      "ecommerce": {
                        "items": [{
                             "item_id": iid,
                             "item_name": pnm,
                             "promotion_id": pid,
                             "promotion_name": pnm,
                             "creative_name": cnm,
                             "creative_slot": csl
                        }]
                      }
                  })
  })
  //product list ga4 push function
  function gaviewproducts(bselection,proitems,btitle,arrflag){
     $(bselection).each(function(){
           var protitleshow = $(this).find(".real-product-title").text();
           var proidshow = $(this).find(".productid_ga4").text();
           var product_sku = $(this).find(".productsku_ga4").text();
           var product_realsku = $(this).find(".productsku2_ga4").text();
           if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
              product_realsku = "not set";
           }
      
           var propriceshow = $(this).find(".grid-product__price--current .grid-product__price--from .money").text().replace(/[^0-9.]/g, '');
           var provariantshow = $(this).find(".productvariant_ga4").text();
           var proindexshow = $(this).index();
           var proquantityshow = 1;
           var procurrencyshow = "USD";
           var procategoryshow = $(this).find(".productcategory_ga4").text();
           if(GAiiv($(this))&&arrflag[proindexshow] !== proindexshow){
               proitems.push({
                   "item_id": proidshow,
                   "item_name": protitleshow,
                   "product_sku": product_realsku,
                   "price": propriceshow,
                   "item_category": procategoryshow,
                   "item_variant": provariantshow,
                   "item_list_name": btitle,
                   "index": proindexshow,
                   "quantity": proquantityshow,
                   "currency": procurrencyshow
               });
              arrflag[proindexshow] = proindexshow;
           }
    });
     if(proitems.length>0){
             // console.log({
             //     "event":  "dle_view_promotion",
             //     "ecommerce":  {
             //         "items": proitems
             //     }
             // });
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              "event": "dle_view_item_list",
              "ecommerce": {
                "items": proitems
              }
          })
       };
  }
  // product list ga4 click push
  function clickpushproduct(thisobj,prolistname){
     var protitleshow = $(thisobj).find(".real-product-title").text();
                 var proidshow = $(thisobj).find(".productid_ga4").text();
                 var product_sku = $(thisobj).find(".productsku_ga4").text();
                 var product_realsku = $(thisobj).find(".productsku2_ga4").text();
                 if(product_realsku=='' || product_realsku==null || product_realsku==undefined || product_realsku.length == 0){
                    product_realsku = "not set";
                 }
                 var propriceshow = $(thisobj).find(".grid-product__price--current .grid-product__price--from .money").text().replace(/[^0-9.]/g, '');
                 var provariantshow = $(thisobj).find(".productvariant_ga4").text();
                 var proindexshow = $(thisobj).index();
                 var proquantityshow = 1;
                 var procurrencyshow = "USD";
                 var procategoryshow = $(thisobj).find(".productcategory_ga4").text();
                 sendProlistname(prolistname);
                 sendProindex(proidshow,prolistname,proindexshow);

                // select_promotion 
                  dataLayer.push({ ecommerce: null });
                  dataLayer.push({
                      "event": "dle_select_item",
                      "ecommerce": {
                        "items": [{
                             "item_id": proidshow,
                             "item_name": protitleshow,
                             "product_sku": product_realsku,
                             "price": propriceshow,
                             "item_category": procategoryshow,
                             "item_variant": provariantshow,
                             "item_list_name": prolistname,
                             "index": proindexshow,
                             "quantity": proquantityshow,
                             "currency": procurrencyshow
                        }]
                      }
                  })
  }
  // homepage bestseller product lists
    var hotflag={};
  function viewHomehotlists(){
    var proitems=new Array();
    var blockselction="#homepage-bestseller-container .product-grid .grid-item.grid-product";
    var blocktitle="homepage_bestsellers";
    gaviewproducts(blockselction,proitems,blocktitle,hotflag);
  }
   function viewprohotHandle(){
       viewHomehotlists();
   }
 window.addEventListener('scroll', GAgdb(viewprohotHandle,1000));
    $("#homepage-bestseller-container .product-grid .grid-item.grid-product").click(function(){
          var prolistname="homepage_bestsellers";
              clickpushproduct(this,prolistname);
     }); 
  // homepage what's new product lists
      var newflag={};
  function viewHomenewlists(){
    var proitems=new Array();
    var blockselction="#homepage-whatnew-container .product-grid .grid-item.grid-product";
    var blocktitle="homepage_whatsnew";
    gaviewproducts(blockselction,proitems,blocktitle,newflag);
  }
   function viewpronewHandle(){
       viewHomenewlists();
   }
 window.addEventListener('scroll', GAgdb(viewpronewHandle,1000));
    $("#homepage-whatnew-container .product-grid .grid-item.grid-product").click(function(){
          var prolistname="homepage_whatsnew";
              clickpushproduct(this,prolistname);
     }); 
  // homepage type 4c edge product lists
      var fcedgeflag={};
  function viewHomeedgelists(){
    var proitems=new Array();
    var blockselction="#homepage-4cpro-container .product-grid .grid-item.grid-product";
    var blocktitle="homepage_type4cedgehairlinewigs";
    gaviewproducts(blockselction,proitems,blocktitle,fcedgeflag);
  }
   function viewproedgeHandle(){
       viewHomeedgelists();
   }
 window.addEventListener('scroll', GAgdb(viewproedgeHandle,1000));
    $("#homepage-4cpro-container .product-grid .grid-item.grid-product").click(function(){
          var prolistname="homepage_type4cedgehairlinewigs";
              clickpushproduct(this,prolistname);
     }); 
  // homepage pre cut product lists
      var precutflag={};
  function viewHomepcutlists(){
    var proitems=new Array();
    var blockselction="#homepage-4cpro-container .product-grid .grid-item.grid-product";
    var blocktitle="homepage_precutlacewigs";
    gaviewproducts(blockselction,proitems,blocktitle,precutflag);
  }
   function viewpropcutHandle(){
       viewHomepcutlists();
   }
 window.addEventListener('scroll', GAgdb(viewpropcutHandle,1000));
    $("#homepage-4cpro-container .product-grid .grid-item.grid-product").click(function(){
          var prolistname="homepage_precutlacewigs";
              clickpushproduct(this,prolistname);
     }); 
})